import { render, staticRenderFns } from "./log-delete.vue?vue&type=template&id=ab229328&scoped=true&lang=pug&"
import script from "./log-delete.vue?vue&type=script&lang=js&"
export * from "./log-delete.vue?vue&type=script&lang=js&"
import style0 from "./log-delete.vue?vue&type=style&index=0&id=ab229328&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab229328",
  null
  
)

export default component.exports